import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Week from "./Week/Week.js";
import data from "../../Data/weeks/weeksData.json";

export default function Prevention() {
  // Разворачиваем массив один раз
  const reversedData = [...data].reverse();

  const [index, setIndex] = useState(0);
  const navigate = useNavigate();

  const handlePrev = () => {
    setIndex((prev) => (prev === 0 ? reversedData.length - 1 : prev - 1));
  };

  const handleNext = () => {
    setIndex((prev) => (prev === reversedData.length - 1 ? 0 : prev + 1));
  };

  const handleDetailsClick = () => {
    const currentWeek = reversedData[index];

    navigate("/patients/week", {
      state: { weekId: currentWeek.id },
    });
  };

  // Максимальное количество отображаемых точек
  const maxDots = 10;

  // Определяем диапазон отображаемых точек
  let dotsStart = 0;
  let dotsEnd = reversedData.length;

  if (reversedData.length > maxDots) {
    // Стараемся держать активную точку примерно в центре
    dotsStart = index - Math.floor(maxDots / 2);

    // Если ушли слишком далеко влево
    if (dotsStart < 0) {
      dotsStart = 0;
    }

    dotsEnd = dotsStart + maxDots;

    // Если ушли слишком далеко вправо
    if (dotsEnd > reversedData.length) {
      dotsEnd = reversedData.length;
      dotsStart = dotsEnd - maxDots;
    }
  }

  const visibleDots = reversedData.slice(dotsStart, dotsEnd);

  return (
    <section className="prevention">
      <div className="prevention__block">
        <Week
          Week_text_h2={reversedData[index].title}
          Week_text_p={reversedData[index].text || ""}
        />

        <h4 className="prevention__button">
          <button onClick={handleDetailsClick} className="prevention__link">
            Подробнее
          </button>
        </h4>

        <button className="prevention__left" onClick={handlePrev}></button>

        <button className="prevention__right" onClick={handleNext}></button>

        <div className="prevention__dots">
          {visibleDots.map((week, i) => {
            const realIndex = dotsStart + i;

            return (
              <button
                key={week.id}
                className={`prevention__dot-${
                  realIndex === index ? "active" : "inactive"
                }`}
                onClick={() => setIndex(realIndex)}
              ></button>
            );
          })}
        </div>
      </div>
    </section>
  );
}
